/* eslint-disable complexity */
import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import Button from '../../shared/buttons/Button';
import TextInput from '../../shared/inputs/TextInput';
import Logos from '../Home/components/Logos';
import ErrorMessage from '../../shared/message/ErrorMessage';
import { postAccount, login } from '../../api/cloudApiGenerated';
import formatValidation from '../../utils/formatValidation';
import { useCaptcha } from '../../utils/SignupHelpers';
import qs from 'qs';
import config from './../../config';

class SignupPage extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.validateForm = this.validateForm.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.updateState = this.updateState.bind(this);
    this.oauthSignup = this.oauthSignup.bind(this);

    const query = qs.parse(location.search, { ignoreQueryPrefix: true });

    this.state = {
      isSignedIn: false,
      hasAccount: false,
      campaign_code: query.utm_campaign || null,
      error: false,
      form: {
        name: {
          value: '',
          error: false
        },
        email: {
          value: '',
          error: false
        },
        password: {
          value: '',
          error: false
        },
        passwordConfirmation: {
          value: '',
          error: false
        }
      },
      coupon_code: query.coupon,
      googleBtnIcon: <img src="/static/images/btn_google_dark_normal_ios.svg" />
    };
  }

  oauthSignup() {
    window.location.replace(this.props.paths.oauthSignup);
  }

  validateForm() {
    let form = this.state.form;
    let valid = true;

    if (form.name.value.length < 2) {
      form.name.error = 'Your name needs to be at least 2 characters long';
    } else {
      form.name.error = false;
    }

    const emailValid = formatValidation.email(form.email.value);
    if (!emailValid) {
      form.email.error = 'The email you specified is not a valid email format';
    } else {
      form.email.error = false;
    }

    if (form.password.value.length < 8) {
      form.password.error = 'Your password needs to be at least 8 characters long';
      valid = false;
    } else {
      form.password.error = false;
    }

    if (form.password.value !== form.passwordConfirmation.value) {
      form.passwordConfirmation.error = 'The passwords you entered do not match';
      valid = false;
    } else {
      form.passwordConfirmation.error = false;
    }

    if (!valid) {
      this.setState({ form });
    }

    return valid;
  }

  onSubmit(event) {
    event.preventDefault();
    const form = this.state.form;
    const valid = this.validateForm();
    const action = 'login';

    useCaptcha(config, action).then((token) => {
      if (valid) {
        postAccount({
          username: form.name.value,
          email: form.email.value,
          password: form.password.value,
          captchaResponse: token,
          action
        })
          .then((d) => {
            this.props.googleTagManager.tagSub(d.team_id, { id: 1, name: 'Free Plan' }, d.plan_id);

            login(form.email.value, form.password.value).then(() => {
              this.props.onLoggedIn();
              if (!this.state.coupon_code) {
                this.props.history.push({
                  pathname: this.props.redirect
                });
              } else {
                const redirect = this.props.paths.profileSubscription;
                this.props.history.push({
                  pathname: redirect,
                  search: '?coupon=' + this.state.coupon_code
                });
              }
              /*
          this.props.history.push({
            pathname: this.props.redirect
          });*/
            });
          })
          .catch((error) => {
            this.setState({
              error: (error.message.join && error.message.join(' ')) || error.message
            });
            throw new Error(error);
          });
      }
    });
  }

  updateState(event) {
    const field = event.target.name;
    let form = this.state.form;
    form[field].value = event.target.value;
    form[field].error = false;
    return this.setState({ form });
  }

  render() {
    let state = this.state;
    let isSignedIn = state.isSignedIn;
    let hasAccount = state.hasAccount;
    let form = state.form;

    return (
      <div className="dark-layout signup-page">
        <div className="floating-login-button hidden-sm hidden-md hidden-lg">
          <NavLink to={this.props.paths.login}>Login</NavLink>
        </div>
        <div className="page-inner-div">
          <section className="page-section clearfix">
            <div className="page-form clearfix">
              {isSignedIn && (
                <p>
                  You can {hasAccount ? 'only add a Google Login' : 'add both login types'} to your existing account.
                </p>
              )}
              <form role="form" action={this.onSubmit}>
                <div className="page-div">
                  <div className="sharing-text hidden-sm hidden-md hidden-lg">
                    Sharing your data through attractive, interactive charts/maps is now simpler than ever
                  </div>
                  <h3 className="hidden-xs"> Sign up with email </h3>
                  <div className="hidden-sm hidden-md hidden-lg"> Sign up for a 14 day free trial </div>
                  <ErrorMessage error={this.state.error} dismissable={false} />
                  <TextInput
                    inlineLabel="Name:"
                    label=""
                    name="name"
                    value={form.name.value}
                    placeholder={hasAccount ? '' : 'Name'}
                    disabled={hasAccount}
                    onChange={this.updateState}
                    labelClass={' hidden-sm'}
                  />

                  <TextInput
                    label=""
                    inlineLabel="Email:"
                    name="email"
                    type="email"
                    value={form.email.value}
                    placeholder={hasAccount ? '' : 'Email'}
                    disabled={hasAccount}
                    onChange={this.updateState}
                    labelClass={' hidden-sm'}
                  />

                  <TextInput
                    inlineLabel="Password:"
                    label=""
                    name="password"
                    type="password"
                    value={form.password.value}
                    placeholder={hasAccount ? '' : 'Enter password (minimum 8 characters)'}
                    disabled={hasAccount}
                    onChange={this.updateState}
                    labelClass={' hidden-sm'}
                  />

                  <TextInput
                    label=""
                    inlineLabel="Confirm:"
                    name="passwordConfirmation"
                    type="password"
                    value={form.passwordConfirmation.value}
                    placeholder={hasAccount ? '' : 'Type your password again'}
                    disabled={hasAccount}
                    onChange={this.updateState}
                    labelClass={' hidden-sm'}
                  />
                  <div className="text-center mx-20">
                    <div className="mb-4">
                      This site is protected by reCAPTCHA and the Google{' '}
                      <a href="https://policies.google.com/privacy">Privacy Policy</a> and{' '}
                      <a href="https://policies.google.com/terms">Terms of Service</a> apply. <br />
                    </div>
                    By Clicking <span className="hidden-xs">Create new account</span>
                    <span className="hidden-sm hidden-md hidden-lg">Start Free Trial</span>, you agree to our{' '}
                    {<a href="https://www.everviz.com/terms">terms of service</a>} and{' '}
                    {<a href="https://www.everviz.com/privacy">privacy policy</a>}
                  </div>
                  <div className="btn-page-div">
                    <Button
                      buttonText={isSignedIn ? 'Add new sign in' : 'Create new account'}
                      buttonClass={
                        'hidden-xs btn bulk-action bulk-action-btn' + (hasAccount ? ' disabled="disabled"' : '')
                      }
                      type="submit"
                      onClick={this.onSubmit}
                    />
                    <Button
                      buttonText={isSignedIn ? 'Add New Sign in' : 'Start Free Trial'}
                      buttonClass={
                        'hidden-sm signup-button hidden-md hidden-lg btn bulk-action bulk-action-btn' +
                        (hasAccount ? ' disabled="disabled"' : '')
                      }
                      type="submit"
                      onClick={this.onSubmit}
                    />
                  </div>
                  <div className="">
                    {isSignedIn && (
                      <div className="alternative">
                        Dont want to add a sign in? <NavLink to={this.props.paths.frontPage}>Go to frontpage.</NavLink>
                      </div>
                    )}
                    {!isSignedIn && (
                      <div className="alternative hidden-xs">
                        Already have an account? <NavLink to={this.props.paths.login}>Sign in.</NavLink>
                      </div>
                    )}
                  </div>
                </div>
              </form>

              <div className="page-alternative hidden-xs">
                <h3 className="hidden-xs text-header">Do you have a Google account?</h3>
                <a
                  className="btn-google"
                  href={
                    this.props.paths.oauthSignup +
                    (this.state.coupon_code ? '?coupon_code=' + this.state.coupon_code : '')
                  }
                >
                  {this.state.googleBtnIcon}
                  <span>Sign up with Google</span>
                </a>
              </div>
              <div className="form-fields hidden-sm hidden-md hidden-lg">
                Or sign up with <a href={this.props.paths.oauthSignup}> Google Authentication</a>
              </div>
            </div>

            {(form.name.error || form.email.error || form.password.error || form.passwordConfirmation.error) && (
              <div className="alert alert-danger">
                <ul>
                  {form.name.error && <li>{form.name.error} </li>}
                  {form.email.error && <li>{form.email.error} </li>}
                  {form.password.error && <li>{form.password.error} </li>}
                  {form.passwordConfirmation.error && <li>{form.passwordConfirmation.error} </li>}
                </ul>
              </div>
            )}
          </section>
          <div className="getting-started-iframe hidden-sm hidden-md hidden-lg">
            Check this video how to get started in 3 simple steps:
          </div>
          <iframe
            className="hidden-sm hidden-md hidden-lg"
            src="https://www.youtube.com/embed/lflZysaJDJM"
            frameBorder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen={true}
          />
        </div>
        <Logos />
      </div>
    );
  }
}

SignupPage.propTypes = {
  paths: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  redirect: PropTypes.string.isRequired,
  onLoggedIn: PropTypes.func.isRequired,
  googleTagManager: PropTypes.func
};

export default SignupPage;
